var _rect, _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonthReportPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 44,
    viewBox: "0 0 88 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 44,
    rx: 22,
    fill: "#C0C0C0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1512_32899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 19.4974V13.6641H31V19.4974",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0013 27H19.3346C18.8926 27 18.4687 26.8244 18.1561 26.5118C17.8436 26.1993 17.668 25.7754 17.668 25.3333V21.1667C17.668 20.7246 17.8436 20.3007 18.1561 19.9882C18.4687 19.6756 18.8926 19.5 19.3346 19.5H32.668C33.11 19.5 33.5339 19.6756 33.8465 19.9882C34.159 20.3007 34.3346 20.7246 34.3346 21.1667V25.3333C34.3346 25.7754 34.159 26.1993 33.8465 26.5118C33.5339 26.8244 33.11 27 32.668 27H31.0013",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 23.6641H21V30.3307H31V23.6641Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.326 14.732H56.326V24.953H54.326V14.732ZM52.4144 19.2182C52.4144 21.3343 50.7127 22.826 48.5304 22.826C46.3481 22.826 44.6354 21.3343 44.6409 19.2182C44.6354 17.1354 46.3481 15.6326 48.5304 15.6326C50.7127 15.6326 52.4144 17.1354 52.4144 19.2182ZM46.5912 19.2182C46.5801 20.4061 47.4199 21.0912 48.5304 21.0912C49.6077 21.0912 50.4475 20.4061 50.4475 19.2182C50.4475 18.0635 49.6077 17.3674 48.5304 17.3674C47.4199 17.3674 46.5801 18.0635 46.5912 19.2182ZM48.8122 23.9199V27.0856H56.7017V28.6934H46.7956V23.9199H48.8122ZM68.7287 20.3232V14.7099H70.6071V28.942H68.7287V21.9696H67.6127V28.2845H65.7508V14.9586H67.6127V20.3232H68.7287ZM62.8557 15.826V16.9696C62.8447 18.4779 63.6403 19.9254 65.5132 20.5829L64.5187 22.0746C63.2425 21.616 62.3806 20.7541 61.8778 19.6823C61.3696 20.8812 60.4524 21.837 59.0657 22.3564L58.0546 20.8646C60.027 20.1464 60.8557 18.6215 60.8613 16.9696V15.826H62.8557ZM62.8171 21.837V24.279C63.6734 24.2238 64.5132 24.1519 65.2646 24.0414L65.3696 25.4945C63.0602 25.9751 60.1265 26.0414 58.3364 26.0359L58.0657 24.4061C58.8502 24.4061 59.8392 24.395 60.8944 24.3674V21.837H62.8171Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1512_32899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(16 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthReportPrint);
export default __webpack_public_path__ + "static/media/month_report_print.b24891f97894e5449e422439d5ea16d4.svg";
export { ForwardRef as ReactComponent };